import { MenuItem } from './menu';

export const defaultMenuItems: MenuItem[] = [
  { id: 'inventory', title: 'Inventory', type: 'link', href: '/inventory', ranking: 1500, tier: 1 },
  // { id: 'inventoryCheck', title: 'Inventory Check', type: 'link', href: '/inventoryCheck', ranking: 1500, tier: 3 },
  { id: 'agp', title: 'AGP', type: 'link', href: '/agp', ranking: 1500, tier: 3 },
  { id: 'recipes', title: 'Recipes', type: 'link', href: '/recipes', ranking: 1500, tier: 1 },
  { id: 'batches', title: 'Batches', type: 'link', href: '/batches', ranking: 1500, tier: 1 },
  {
    id: 'shopping-list',
    title: 'Shopping List',
    type: 'link',
    href: '/shopping-list',
    ranking: 1500,
    tier: 1,
  },
  { id: 'stock', title: 'Stock', type: 'link', href: '/stock', ranking: 1500, tier: 2 },
  { id: 'planning', title: 'Planning', type: 'link', href: '/plan', ranking: 1500, tier: 2 },
  { id: 'tools', title: 'Tools', type: 'link', href: '/tools', ranking: 1500, tier: 1 },
  { id: 'invoices', title: 'Invoices', type: 'link', href: '/invoices', ranking: 1500, tier: 3 },
  // { id: 'sales', title: 'Sales', type: 'link', href: '/sales', ranking: 1500, tier: 3, disabled: true },
  { id: 'audit', title: 'Audit', type: 'link', href: '/audit', ranking: 1500, tier: 3 },
  {
    id: 'suggestions',
    title: 'Suggestions',
    type: 'link',
    href: 'https://forms.clickup.com/90151092123/f/2kyprzwv-535/177IWD6954V55U9BPT',
    ranking: 1500,
    tier: 1,
    external: true,
  },
  { id: 'wiki', title: 'Wiki', type: 'link', href: '/wiki', ranking: 1500, tier: 3 },
];
